import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "material-icons" };
export default /*#__PURE__*/ _defineComponent({
    props: {
        name: null
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(props.name), 1));
        };
    }
});
